var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "454pt",
    viewBox: "-53 0 454 454.57143",
    width: "454pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.429688 38.574219h329.605468v406.859375h-329.605468zm0 0",
    fill: "#7bbd91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m339.035156 454.570312h-329.605468c-5.050782 0-9.144532-4.089843-9.144532-9.140624v-406.859376c0-5.050781 4.09375-9.140624 9.144532-9.140624h329.605468c5.050782 0 9.144532 4.089843 9.144532 9.140624v406.859376c0 5.050781-4.09375 9.140624-9.144532 9.140624zm-320.464844-18.285156h311.324219v-388.570312h-311.324219zm0 0",
    fill: "#2a3d4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m258.230469 68.011719h-168l42.289062-58.871094h83.425781zm0 0",
    fill: "#4b6981"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m258.230469 77.152344h-168c-3.425781 0-6.570313-1.921875-8.132813-4.972656-1.566406-3.046876-1.289062-6.714844.710938-9.5l42.285156-58.867188c1.714844-2.394531 4.480469-3.8125 7.425781-3.8125h83.425781c2.941407 0 5.710938 1.417969 7.425782 3.8125l42.285156 58.867188c2 2.785156 2.277344 6.453124.710938 9.5-1.5625 3.050781-4.707032 4.972656-8.136719 4.972656zm-150.171875-18.285156h132.347656l-29.148438-40.582032h-74.050781zm0 0",
    fill: "#2a3d4f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m270.230469 242.003906c0 53.019532-42.980469 96-96 96s-96-42.980468-96-96c0-53.019531 42.980469-96 96-96s96 42.980469 96 96zm0 0",
    fill: "#ffd766"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a3d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m174.230469 347.144531c-57.976563 0-105.140625-47.171875-105.140625-105.144531s47.164062-105.144531 105.140625-105.144531c57.980469 0 105.144531 47.171875 105.144531 105.144531s-47.164062 105.144531-105.144531 105.144531zm0-192c-47.890625 0-86.855469 38.960938-86.855469 86.855469s38.964844 86.855469 86.855469 86.855469c47.894531 0 86.859375-38.960938 86.859375-86.855469s-38.964844-86.855469-86.859375-86.855469zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.65625 280.5c-2.339844 0-4.679688-.894531-6.464844-2.679688l-27.554687-27.550781c-3.570313-3.574219-3.570313-9.359375 0-12.929687 3.574219-3.570313 9.359375-3.570313 12.929687 0l21.089844 21.089844 52.242188-52.242188c3.570312-3.570312 9.355468-3.570312 12.925781 0 3.574219 3.570312 3.574219 9.355469 0 12.929688l-58.703125 58.703124c-1.785156 1.785157-4.125 2.679688-6.464844 2.679688zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarea);
export default __webpack_public_path__ + "static/media/tarea.ec9922ea6bcb88722ff73a27ece248d1.svg";
export { ForwardRef as ReactComponent };